const { LocaleCode } = require('./LocaleCode')

/** @type {import('next').NextConfig['i18n']} */
module.exports = {
	defaultLocale: LocaleCode.options[0],
	locales: LocaleCode.options,
	localeDetection: false,
}
